import { stateInHashReplacer } from './stateInHashReplacer';
/**
 * Create the state buffer for b2c redirects. Will be extracted by `handleStateAfterLoginComplete`
 * after login completes.
 */
export const getRedirectState = () => {
    //MSAL is being frustrating and insists on replacing my state.
    if (window.location.pathname.includes('/auth')) {
        return undefined;
    }
    const urlAfterAuthLanding = window.location.href
        // We want a relative path, not a full url
        .replace(window.location.origin, '')
        // Hash that will match the "state=stuff" (including the stuff) and the preceding ? or # token
        // because MSAL seems to pick randomly whether it wants to use hash or query params.
        .replace(stateInHashReplacer, '?');
    return btoa(JSON.stringify({
        urlAfterAuthLanding,
    }));
};
